package or.garden.manager.components

import androidx.compose.runtime.Composable
import or.garden.manager.domain.GardenHttpClient
import org.jetbrains.compose.web.dom.*

@Composable
fun Sidebar(
    activeTab: String,
    expanded: Boolean,
    onTabChange: (String) -> Unit,
    onLogout: () -> Unit
) {
    val userRole = GardenHttpClient.role

    Div({
        val sidebarClasses = mutableListOf(
            "bg-[#134130]", "text-white", "flex", "flex-col", "transition-all", "duration-300",
            "sticky", "top-0", "h-screen", "overflow-hidden"
        )
        sidebarClasses.add(if (expanded) "w-64" else "w-20")
        classes(sidebarClasses)
    }) {
        // Sidebar Header / Logo
        Div({ classes("p-6", "flex", "items-center", "gap-3", "mb-4") }) {
            Div({
                classes(
                    "w-10", "h-10", "bg-[#FFFFFF]", "rounded-lg", "flex", "items-center", "justify-center", "flex-shrink-0", "overflow-hidden"
                )
            }) {
                Img(
                    src = "composeResources/gardenmanager.composeapp.generated.resources/drawable/home.webp",
                    attrs = { classes("w-2/3", "h-2/3", "object-contain") })
            }
            if (expanded) {
                Span({
                    classes("font-bold", "text-xl", "tracking-tight")
                }) { Text("Moja bašta") }
            }
        }

        // Navigacijske stavke
        Div({ classes("flex-1", "px-3", "space-y-2") }) {
            SidebarNavItem(
                "Moje leje", "fa-th-large", activeTab == "Beds", expanded
            ) { onTabChange("Beds") }
            SidebarNavItem(
                "Navodnjavanje", "fa-tint", activeTab == "Irrigation", expanded
            ) { onTabChange("Irrigation") }
            SidebarNavItem(
                "Kalendar", "fa-calendar-alt", activeTab == "Calendar", expanded
            ) { onTabChange("Calendar") }
            SidebarNavItem(
                "Katalog kultura", "fa-database", activeTab == "Database", expanded
            ) { onTabChange("Database") }
            SidebarNavItem(
                "Prirodna đubriva", "fa-leaf", activeTab == "NaturalFertilizers", expanded
            ) { onTabChange("NaturalFertilizers") }

            if (userRole == "ADMIN") {
                SidebarNavItem(
                    "Admin Panel", "fa-user-shield", activeTab == "Admin", expanded
                ) { onTabChange("Admin") }
            }
        }

        // Sidebar Footer
        Div({ classes("p-4", "border-t", "border-[#1A5C43]", "space-y-2") }) {
            SidebarNavItem(
                "Sadnja - Ovaj mjesec", "fa-calendar-check", activeTab == "Planting", expanded
            ) { onTabChange("Planting") }
            SidebarNavItem(
                "Bilješke", "fa-sticky-note", activeTab == "Notes", expanded
            ) { onTabChange("Notes") }
            SidebarNavItem(
                "Moje sjemenke", "fa-seedling", activeTab == "MySeeds", expanded
            ) { onTabChange("MySeeds") }
            SidebarNavItem(
                "Odjava", "fa-sign-out-alt", activeTab == "logout", expanded
            ) { onLogout() }
        }
    }
}

@Composable
fun SidebarNavItem(
    label: String,
    icon: String,
    isActive: Boolean,
    expanded: Boolean,
    onClick: () -> Unit
) {
    Div({
        val itemClasses = mutableListOf(
            "flex", "items-center", "gap-3", "py-3", "px-4", "rounded-xl", "cursor-pointer", "transition-all", "duration-200"
        )
        if (isActive) {
            itemClasses.add("bg-[#1A5C43]")
            itemClasses.add("text-[#34D399]")
        } else {
            itemClasses.add("text-gray-300")
            itemClasses.add("hover:bg-[#1A5C43]/50")
            itemClasses.add("hover:text-white")
        }
        classes(itemClasses)
        onClick { onClick() }
    }) {
        I({ classes("fas", icon, "text-xl", "w-6", "text-center") })
        if (expanded) {
            Span({ classes("font-medium", "text-sm") }) { Text(label) }
        }
    }
}
